/* ============================================================
   Biwa Wave — Motion
   Two layers of scroll reveal:
   A) every section in <main> fades in (universal coverage), and
   B) key elements rise with stagger for detail.
   3D tilt is kept only on lifestyle tiles (not on product cards).
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  /* [selector, kind, stagger-ms] — detail layer */
  var RULES = [
    ['.bw-hero__content > *', 'up', 140],
    ['.bw-icons__item', 'up', 120],
    ['.bwlk-intro', 'left', 0],
    ['.bwlk-figure', 'up', 130],
    ['.title-wrapper', 'up', 0],
    ['.bw-section-head', 'up', 0],
    ['.bw-inline-head', 'up', 0],
    ['.product-grid .card-wrapper', 'up', 90],
    ['.bw-life', 'scale', 110],
    ['.bw-store', 'up', 130],
    ['.bw-look', 'up', 110],
    ['.bw-lookbook__intro', 'left', 0],
    ['.bw-story__media', 'scale', 0],
    ['.bw-story__text > *', 'up', 90],
    ['.newsletter__wrapper > *', 'up', 100],
    ['.footer__content-top .footer-block', 'up', 110],
    ['.collection__title', 'up', 0],
    ['.rich-text__blocks > *', 'up', 110],
    ['.image-with-text__content > *', 'up', 100],
    ['.image-with-text__media', 'scale', 0],
    ['.multicolumn-list__item', 'up', 110],
    ['.collection-list .card-wrapper', 'up', 100]
  ];

  /* detail observer: small elements */
  var obsDetail = null;
  function detailObserver() {
    if (obsDetail) return obsDetail;
    obsDetail = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bw-in'); obsDetail.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    return obsDetail;
  }

  /* section observer: fires as soon as any part is visible
     (threshold 0 — works for sections taller than the viewport) */
  var obsSection = null;
  function sectionObserver() {
    if (obsSection) return obsSection;
    obsSection = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('bw-in'); obsSection.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -30px 0px' });
    return obsSection;
  }

  function tag(n, kind, delay, forSection) {
    if (n.dataset.bwm) return false;
    n.dataset.bwm = kind;
    if (delay) n.style.setProperty('--bwm-d', delay + 'ms');
    if (reduced || designMode) {
      n.classList.add('bw-in');
    } else {
      (forSection ? sectionObserver() : detailObserver()).observe(n);
    }
    return true;
  }

  function tagAll(root) {
    var scope = root || document;

    /* A) universal: every section inside main fades in */
    scope.querySelectorAll('main .shopify-section').forEach(function (s) {
      tag(s, 'fade', 0, true);
    });

    /* B) detail layer with stagger */
    RULES.forEach(function (rule) {
      var i = 0;
      scope.querySelectorAll(rule[0]).forEach(function (n) {
        if (tag(n, rule[1], (i % 8) * rule[2], false)) i++;
      });
    });
  }

  /* ---- 3D pointer tilt — lifestyle tiles only ---- */
  function attachTilt(root) {
    if (!finePointer || reduced) return;
    (root || document).querySelectorAll('.bw-life').forEach(function (el) {
      if (el.dataset.bwmTilt) return;
      el.dataset.bwmTilt = '1';
      el.classList.add('bwm-tilt');
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform =
          'perspective(900px) rotateX(' + (-py * 5).toFixed(2) + 'deg)' +
          ' rotateY(' + (px * 7).toFixed(2) + 'deg) translateY(-4px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function initAll(root) {
    tagAll(root);
    attachTilt(root);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
